import { useSelector } from "react-redux";

import { ComponentBadges } from "@components";
import { selectAuth } from "@redux";


export const PageBadges = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentBadges
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
